import { getRowHeight } from '../../workbook/base/index';
import { attributes } from '@syncfusion/ej2-base';
/**
 * Sheet module is used for creating row element
 * @hidden
 */
var RowRenderer = /** @class */ (function () {
    function RowRenderer(parent) {
        this.parent = parent;
        this.element = this.parent.createElement('tr', { attrs: { 'role': 'row' } });
    }
    RowRenderer.prototype.render = function (index, isRowHeader) {
        var row = this.element.cloneNode();
        if (index === undefined) {
            row.classList.add('e-header-row');
            return row;
        }
        row.classList.add('e-row');
        var sheet = this.parent.getActiveSheet();
        attributes(row, { 'aria-rowindex': (index + 1).toString() });
        row.style.height = getRowHeight(sheet, index) + "px";
        return row;
    };
    return RowRenderer;
}());
export { RowRenderer };
